import Time from 'model/appointments/timeSlots/time'
import { isNil } from 'ramda'
import { CANCELED_TIME } from 'constants/appointments'

class CanceledTime extends Time {
  constructor(init) {
    super(init)
    // console.log('> CanceledTime constructor -', init)
    if (isNil(init)) return undefined
  }

  // Calculable
  get isCanceledTime() {
    return this.__typename === CANCELED_TIME
  }
}

export default CanceledTime
